import { useObserver } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';

import { useConfig } from '../../hooks';
import HeaderMenuContent from '../HeaderMenuContent/HeaderMenuContent';

const HeaderMenu = () => {
  const {
    fontFamily,
    window: { background, borderRadius, boxShadow }
  } = useConfig();

  return useObserver(() => (
    <Root
      fontFamily={fontFamily}
      background={background}
      borderRadius={borderRadius}
      boxShadow={boxShadow}
      id="headerMenu"
    >
      <Content background={background}>
        <MenuContentWrapper>
          <HeaderMenuContent />
        </MenuContentWrapper>
      </Content>
    </Root>
  ));
};

const Root = styled.div`
  position: absolute;
  display: none;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  width: 100%;
  min-width: 100%;
  font-family: ${props => props.fontFamily};
  border-radius: ${props => props.borderRadius}px;
  z-index: 10;
`;

const Content = styled.main`
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  width: auto;
  min-width: auto;
  height: auto;
  min-height: auto;
  background: ${props => props.background};
  border: none;
  overflow-y: auto;
  overflow-x: hidden;
`;

const MenuContentWrapper = styled.div`
  position: relative;
  flex: 1 0 auto;
`;

export default HeaderMenu;
